import React from 'react'
import './StoryReel.css';
import Story from "./Story";

function StoryReel() {
    return  (
    <div className="storyReel">


            {/*Story*/ }
            <Story image="pic1.png" profileSrc="" title="Happy"/>
            {/*Story*/ }
            <Story image="pic2.png" profileSrc="" title="Sad"/>
            {/*Story*/ }
            <Story image="pic3.png" profileSrc="" title="angry"/>
            {/*Story*/ }
            <Story image="pic4.png" profileSrc="" title="Funny"/>
            {/*Story*/ }
            <Story image="pic5.png" profileSrc="" title="Awake"/>


        </div>
    );
}

export default StoryReel
